import { render, staticRenderFns } from "./ScopeLinks.vue?vue&type=template&id=3801c4be&"
import script from "./ScopeLinks.vue?vue&type=script&lang=ts&"
export * from "./ScopeLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports